export default [
	{
		name: '官方',
		value: '1'
	},
	{
		name: '品牌商',
		value: '2'
	}
]


// WEBPACK FOOTER //
// ./src/lib/dataTypeList.js